"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLanguage = void 0;
const cookie_1 = __importDefault(require("cookie"));
const accept_language_parser_1 = __importDefault(require("accept-language-parser"));
const __1 = require("../..");
const isProd_1 = __importDefault(require("../isProd"));
// Note Japanese explicitly omitted as support for that language is no longer maintained.
const SUPPORTED_LANGUAGES = ['en', 'de', 'es'];
const LANGUAGE_FALLBACK = 'en';
/**
 * Function returns expected language based on request in priority order:
 * 1. Any language specified in the route takes first precedence
 * 2. Any language specified in a cookie takes second precedence
 * 3. User's preferred language is finally assumed via 'Accept-Language' header
 * 4. Fallback to english if all else fails
 */
const getLanguage = (route, cookies, acceptLanguage, geoLocation) => {
    var _a;
    /**
     * Attempt 1: Get language from route
     */
    if ((_a = route === null || route === void 0 ? void 0 : route.context) === null || _a === void 0 ? void 0 : _a.language_code) {
        if (!isProd_1.default) {
            console.log('Setting language based on route context:', route.context.language_code);
        }
        return route.context.language_code;
    }
    /**
     * Attempt 2: Get language from cookie
     */
    const parsedCookies = cookie_1.default.parse(cookies || '');
    const cookieLanguageCode = parsedCookies[__1.LANGUAGE_COOKIE_KEY];
    if (cookieLanguageCode) {
        if (!isProd_1.default) {
            console.log('Setting language based on user cookie:', cookieLanguageCode);
        }
        return cookieLanguageCode.toLowerCase();
    }
    /**
     * Attempt 3: Get language from device/browser preference
     */
    if (acceptLanguage) {
        /**
         * Returns highest priority language code, based on quality (if applicable)
         * Example: "fr-CH, fr;q=0.9, en;q=0.8" Returns "fr"
         * Spec ref https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Accept-Language
         */
        const languages = accept_language_parser_1.default.parse(acceptLanguage);
        // Filter to languages that we support
        const supportedLanguageCodes = languages
            .map(({ code }) => code === null || code === void 0 ? void 0 : code.toLocaleLowerCase())
            .filter((code) => SUPPORTED_LANGUAGES.includes(code));
        const preferredLanguage = supportedLanguageCodes[0];
        if (preferredLanguage) {
            // Do not auto-route esUS users to the Spanish buyflow until
            // we invest more resources in this buyflow. See https://noomhq.atlassian.net/browse/GT-1067
            if (preferredLanguage === 'es' && geoLocation.country_code === 'US') {
                return LANGUAGE_FALLBACK;
            }
            if (!isProd_1.default) {
                console.log('Setting language based on Accept-Language header:', preferredLanguage);
            }
            return preferredLanguage;
        }
    }
    if (!isProd_1.default) {
        console.log('No language overrides found, falling back to default:', LANGUAGE_FALLBACK);
    }
    return LANGUAGE_FALLBACK;
};
exports.getLanguage = getLanguage;
//# sourceMappingURL=index.js.map